// extracted by mini-css-extract-plugin
export const image = "Partner-module--image--2hDxI";
export const root = "Partner-module--root--38u5u";
export const content = "Partner-module--content--tne13";